import { useTranslations } from '@vocab/react';
import { Heading, Stack, Box, Text, Alert } from 'braid-design-system';

import { TextLink } from 'src/components/Link/Link';
import { links } from 'src/links';
import translations from 'src/pages/LinkYourSoftware/.vocab';
import { useIntegrationPartners } from 'src/utils/hooks/useIntegrationPartners';

import { SelectPartnerFilter } from './Request/components/SelectPartnerFilter/SelectPartnerFilter';

export const PartnerSelection = () => {
  const { selectedPartner, partners } = useIntegrationPartners();
  const { t } = useTranslations(translations);

  return (
    <Stack space="xlarge">
      <Heading level="1" align="left">
        {t('linkSeek')}
      </Heading>
      <Stack space="gutter">
        <Text size="large" align="left">
          {t('selectAndFollowRsp')}
        </Text>
        <Text size="large">
          {t('whatsPossible', {
            TextLink: (children) => (
              <TextLink
                href={links.CONNECT_WITH_SEEK.path}
                tracking="partner-selection-whats-possible-link-clicked"
              >
                {children}
              </TextLink>
            ),
          })}
        </Text>
      </Stack>
      <Stack space="gutter">
        <Box
          width="full"
          translate={
            // Google translate seems to crash React on this component
            'no'
          }
        >
          <SelectPartnerFilter />
        </Box>
        {partners.state === 'error' && (
          <Box display="flex">
            <Alert tone="critical">
              <Text>{t('somethingWentWrong')}</Text>
            </Alert>
          </Box>
        )}
        {!selectedPartner && partners.state !== 'error' && (
          <Box display="flex">
            <Alert>
              <Text>{t('selectProviderAbove')}</Text>
            </Alert>
          </Box>
        )}
      </Stack>
    </Stack>
  );
};
